import {
  bool, func, shape, string,
} from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { View } from 'react-native';
import { Link } from 'react-router-dom';
import { LAYOUT, THEME } from 'reactor/common';
import { Icon, Motion, Text } from 'reactor/components';
import { Consumer } from 'context';

import styles from './Aside.style';

const { COLOR } = THEME;

class Aside extends PureComponent {
  static propTypes = {
    active: string,
    items: shape({}),
    onLink: func,
    visible: bool,
  };

  static defaultProps = {
    active: undefined,
    items: {},
    onLink: undefined,
    visible: true,
  };

  render() {
    const {
      props: {
        active, items, onLink, visible,
      },
    } = this;
    const { VIEWPORT: { LANDSCAPE } } = LAYOUT;

    return (
      <Consumer>
        { ({ agency }) => (
          <Motion
            disabled={LANDSCAPE}
            timeline={[{ property: 'left', value: visible ? 0 : '-100%' }]}
            style={[styles.container, LANDSCAPE && styles.elevation]}
          >
            <Fragment>
              { agency && (<Text headline level={5} style={styles.title}>{agency.name}</Text>)}

              { Object.keys(items).map(key => (
                <Link
                  key={items[key].label}
                  onClick={() => onLink(key)}
                  to={items[key].to}
                  style={{ textDecoration: 'none' }}
                >
                  <View style={styles.item}>
                    {items[key].icon && <Icon value={items[key].icon} style={styles.icon} />}
                    <Text color={key === active ? COLOR.PRIMARY : undefined} subtitle level={2}>
                      {items[key].label}
                    </Text>
                  </View>
                </Link>
              ))}
            </Fragment>
          </Motion>
        )}
      </Consumer>
    );
  }
}

export default Aside;
